
import { defineComponent, computed, ref } from 'vue'
import { useStore } from 'vuex'
import { prepareTableColumns, getFormattedColumnValue } from '@/composables/table'

export default defineComponent(
{
    name: 'Basket',
    setup()
    {
        // Use vuex:
        const store = useStore()
        // Get basket from store:
        const basketItems = store.getters['basket/getBasket']
        // Set columns to display based on grant type:
        const columns = prepareTableColumns(1)
        const sortColumn = ref('none')

        // Computed vars from data:
        const getBasketCount = computed(() =>
        {
            return store.getters['basket/getBasketCount']
        })
        const numberOfItemsText = computed(() =>
        {
            if(getBasketCount.value === undefined)
            {
                return '0 items in your basket'
            }
            if(getBasketCount.value === 1)
            {
                return getBasketCount.value + ' item in your basket'
            }
            return getBasketCount.value + ' items in your basket'
        })
        // Handle removing to basket:
        const removeFromBasket = function(index: string)
        {
            store.commit('basket/removeFromBasket', index)
        }
        // Return data:
        return {
            basketItems,
            columns,
            getFormattedColumnValue,
            sortColumn,
            getBasketCount,
            numberOfItemsText,
            removeFromBasket
        }
    }
})
